import { API_BASE } from '.'
import { APIResult } from '../utils/types'
import { List } from './types/lists'

// export function createTopic(
//   topic: string,
//   quantity?: number,
//   method?: string
// ): Promise<APIResult<List>> {
//   return instance
//     .get('/api/openai/topic', {
//       params: {
//         topic,
//         quantity,
//         method,
//       },
//     })
//     .catch((e) => err(e))
//     .then((res) => getResult<List>(res))
// }

export function createTopic(
  topic: string,
  quantity?: number,
  method?: string
): Promise<APIResult<List>> {
  return new Promise((resolve, reject) => {
    let url = `/api/openai/topic?topic=${encodeURIComponent(topic)}&quantity=${quantity || ''}&method=${method || ''}`

    if (API_BASE) {
      url = `${API_BASE}${url}`
    }

    const eventSource = new EventSource(url)

    eventSource.onmessage = (event) => {
      if (event.data === 'keepalive') {
        // optionally: set progress UI here
        return
      }

      // final payload arrives here
      try {
        const parsed = JSON.parse(event.data)
        resolve(parsed)
      } catch (err) {
        reject(err)
      }

      eventSource.close()
    }

    eventSource.onerror = (err) => {
      console.error('SSE error', err)
      eventSource.close()
      reject(err)
    }
  })
}
